import { addItems } from '../../../scripts/cartApi';
import { initCart, openSideCart } from '../../common/side-cart/side-cart';
import { sendCustomEvent } from '../../../scripts/config/analytics';

export const initWorksWithBuyNow = () => {
  const addToCartForms = document.querySelectorAll(
    '[data-works-with-integration-buy-now-product-form]'
  );

  addToCartForms.forEach((addToCartForm) => {
    addToCartForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      addToCartForm.setAttribute('data-loading', 'true');

      await initCart();

      const formData = new FormData(addToCartForm);
      const variantId = formData.get('id');
      const productTitle = formData.get('title');
      const quantity = 1;

      const items = [
        {
          id: Number(variantId),
          quantity: Number(quantity),
          properties: {},
        },
      ];

      try {
        await addItems(items);
        addToCartForm.setAttribute('data-error', 'false');

        const { sideCart } = window;

        sideCart.updateView(null, openSideCart);

        sendCustomEvent({
          category: 'Works With Buy Now',
          action: 'Add to cart',
          label: productTitle,
        });
      } catch (err) {
        console.error(err);
        addToCartForm.setAttribute('data-error', 'true');
      }

      addToCartForm.setAttribute('data-loading', 'false');
    });
  });
};
